export default "__VITE_ASSET__DiEyDzLE__"